import {WidgetDescription} from '../../components/layout/widget/widget-description';
import {DEX_TX_HISTORY_WIDGET_TYPE_ID} from './dex-tx-history-widget-type-id';
import {DexTxHistoryWidgetComponent} from './dex-tx-history-widget.component';
import {DexTxHistoryWidgetImplementation} from './dex-tx-history-widget.implementation';
import {DexTxHistoryWidgetSettingsComponent} from './settings/dex-tx-history-widget-settings.component';
import {DexTxHistoryWidgetSettingsService} from './settings/dex-tx-history-widget-settings.service';

export const DEX_TX_HISTORY_WIDGET_DESCRIPTION: WidgetDescription = {
    widgetTypeId:              DEX_TX_HISTORY_WIDGET_TYPE_ID,
    widgetLabel:               'Transaction History', // TODO: locale
    widgetImplementationType:  DexTxHistoryWidgetImplementation,
    widgetComponentType:       DexTxHistoryWidgetComponent,
    widgetSettingsServiceType: DexTxHistoryWidgetSettingsService,
    settingsSchema:            [
        {
            name:        'title',
            isShareable: false
        }
    ],
    hasGroupingSupport:          false,
    widgetSettingsComponentType: DexTxHistoryWidgetSettingsComponent
};
